import { render, staticRenderFns } from "./VaultStats.vue?vue&type=template&id=f3c73ab0"
import script from "./VaultStats.vue?vue&type=script&lang=js"
export * from "./VaultStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports